import type { IHttpScrapePathStruct } from '@remote/type/cinema'
import type { ISourceItem, ISourceItemData } from './type'

export function logs (..._args: any[]) {
  console.log('[片库][刮削设置]', ..._args)
}

export function extractUUID (mountPath: string) {
  if (/^\/(?:xos_storage|xos_drive)\/v1\/([^/]+)/.test(mountPath)) {
    return RegExp.$1
  }
  return ''
}

function getDiskName (id: string) {
  // TODO: 获取磁盘名称
  return ''
}

export function buildSourceList (list: IHttpScrapePathStruct[]) {
  const internalList: ISourceItemData[] = []
  const externalMap: { [uuid: string]: ISourceItemData[] } = {}
  list.forEach(item => {
    const { path, path_id, disk_name } = item
    const isInternal = !path.startsWith('/')
    if (isInternal) {
      const rootName = '内置磁盘'
      const dirs = path.replace(/\/$/, '').replace(/^\.\//, '').replace(/^\/(xos_storage|xos_drive)\/v1\/[^/]+\//, '').split('/')
      const [name] = dirs.slice(-1)
      const dir = ['', rootName].concat(dirs.slice(0, -1)).join('/')
      const sourceItem: ISourceItemData = {
        id: path_id,
        path,
        name,
        dir,
      }
      const isSpecialFolder = path.replace(/^\.\//, '') === '我的下载'
      if (isSpecialFolder) {
        internalList.unshift(sourceItem)
      } else {
        internalList.push(sourceItem)
      }
    } else {
      const uuid = extractUUID(path)
      const rootName = getDiskName(uuid) || disk_name
      const dirs = path.replace(/\/$/, '').replace(/^\.\//, '').replace(/^\/(xos_storage|xos_drive)\/v1\/[^/]+\//, '').split('/')
      const [name] = dirs.slice(-1)
      const dir = ['', rootName].concat(dirs.slice(0, -1)).join('/')
      const sourceItem: ISourceItemData = {
        id: path_id,
        path,
        name,
        dir,
      }
      if (Array.isArray(externalMap[uuid])) externalMap[uuid].push(sourceItem)
      else externalMap[uuid] = [sourceItem]
    }
  })

  const internalSource: ISourceItem[] = internalList.length ? [{
    title: '内置磁盘目录',
    id: 'internal',
    data: internalList,
  }] : []
  const externamSource: ISourceItem[] = Object.entries(externalMap).map(([uuid, data], i) => {
    const [first] = data
    const title = getDiskName(uuid) || first?.dir.split('/')[1] || ''
    return {
      title: title ? `${title}目录` : `外接磁盘${i}目录`,
      id: uuid,
      data,
    }
  })
  const sourceList: ISourceItem[] = internalSource.concat(externamSource)

  return sourceList
}

export function flattenSourceList (sections: ISourceItem[]) {
  const list = sections.reduce<ISourceItemData[]>((lst, section) => {
    return lst.concat(section.data)
  }, [])

  return list
}
